import React from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";

import { Alert } from "@mapmycustomers/ui";

import { isLassoContainsClusters } from "@app/scene/map/store/selectors";
import { RootState } from "@app/store/rootReducer";

import messages from "./messages";
import styles from "./Warnings.module.scss";

interface Props {
  containsClusters: boolean;
}

const Warnings: React.FC<Props> = ({ containsClusters }) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      {containsClusters && (
        <Alert
          message={intl.formatMessage(messages.clustersWarning, {
            b: (text) => <b>{text}</b>,
          })}
          showIcon
          type="warning"
        />
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  containsClusters: isLassoContainsClusters(state),
});

export default connect(mapStateToProps)(Warnings);
